<div
  class="ops-project-status-component"
  [class.is-preview]="isPreview"
  [class.expanded]="isExpanded === 1"
  [class.collapsed]="isExpanded === 2"
>
  <div
    *ngIf="isPreview"
    class="sort-button preview-btn bck-{{ _projectStatusId }}"
  >
    <span>{{ _projectStatusName }}</span>
  </div>
  <button
    *ngIf="!isPreview"
    type="button"
    class="sort-button bck-{{ _projectStatusId }}"
    (click)="toggleSort($event)"
  >
    <span>{{ _projectStatusName }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M19.833 16.333L13.9997 11.6663L8.16634 16.333"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>

  <div class="sort-options-wrapper">
    <div class="sort-options-container">
      @for (statusItem of statusOptions; track statusItem.name) {
      <!-- Admin users can select any status -->
      <div
        *ngIf="isAdmin"
        class="sort-option-item"
        [class.disabled]="_projectStatusId === statusItem.id"
        (click)="_projectStatusId !== statusItem.id ? selectOption(statusItem.id) : null"
      >
        <span>{{ statusItem.name }}</span>
      </div>

      <!-- Non-admin users follow the original sequential logic -->
      <ng-container *ngIf="!isAdmin">
        <div
          *ngIf="_projectStatusId + 1 !== statusItem.id && statusItem.id !== 4"
          class="sort-option-item disabled"
        >
          <span>{{ statusItem.name }}</span>
        </div>

        <div
          *ngIf="_projectStatusId + 1 === statusItem.id || statusItem.id === 4"
          class="sort-option-item"
          (click)="selectOption(statusItem.id)"
        >
          <span>{{ statusItem.name }}</span>
        </div>
      </ng-container>
      }
    </div>
  </div>
</div>
